import ExistingRedemptionCard from "./ExistingRedemptionCard.jsx";

function AccessStep({
  driverCode,
  onDriverCodeChange,
  email,
  onEmailChange,
  validating,
  onSubmit,
  error,
  orderStatus
}) {
  const isExpiredCodeError = String(error || "")
    .toLowerCase()
    .includes("code has expired");

  return (
    <div className="landstar-step-content landstar-access-layout">
      <div className="landstar-entry-card landstar-access-card">
        <p className="landstar-kicker">Driver Access</p>
        <h3>Enter your reward code and email</h3>
        <p className="landstar-intro-copy">
          We verify both fields against the Landstar reward record before unlocking the eligible tier.
        </p>

        <ol className="landstar-intro-list landstar-access-list">
          <li>
            <strong>Use the current reward code.</strong> Enter the 5- or 6-digit code exactly as provided.
          </li>
          <li>
            <strong>Match the assigned email.</strong> Use the email tied to the driver reward record.
          </li>
          <li>
            <strong>Continue when ready.</strong> You can return here anytime before final submission.
          </li>
        </ol>

        <form className="landstar-step-form landstar-step-form-compact" onSubmit={onSubmit}>
          <label className="landstar-field-label" htmlFor="driver-code">
            Driver Code
          </label>
          <input
            id="driver-code"
            value={driverCode}
            inputMode="numeric"
            minLength={5}
            maxLength={6}
            pattern="[0-9]{5,6}"
            placeholder="Enter 5- or 6-digit code"
            required
            disabled={validating}
            onChange={(event) => onDriverCodeChange(event.target.value)}
          />
          <p className="landstar-helper-text" aria-live="polite">
            {driverCode.length === 5
              ? "Your 5-digit driver code is ready to validate."
              : "Driver codes may contain either 5 or 6 digits."}
          </p>
          <label className="landstar-field-label" htmlFor="driver-email">
            Email
          </label>
          <input
            id="driver-email"
            type="email"
            value={email}
            placeholder="Enter the reward email"
            required
            disabled={validating}
            onChange={(event) => onEmailChange(event.target.value)}
          />
          {error ? (
            <p className="landstar-error">
              {isExpiredCodeError ? (
                <>
                  Your code has expired. Please contact us at{" "}
                  <a href="mailto:landstar@stran.com">landstar@stran.com</a>.
                </>
              ) : (
                error
              )}
            </p>
          ) : null}

          <hr className="landstar-section-divider" />

          <button type="submit" className="landstar-primary-button" disabled={validating}>
            {validating ? "Checking Eligibility..." : "Continue to Eligible Rewards"}
          </button>
          {validating ? (
            <div className="landstar-inline-progress" aria-live="polite">
              <span className="landstar-inline-progress-bar" />
              <p className="landstar-helper-text">
                Validating the reward code and matching email now.
              </p>
            </div>
          ) : null}
        </form>

        <ExistingRedemptionCard orderStatus={orderStatus} />
      </div>
    </div>
  );
}

export default AccessStep;
